/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import Wizard from '../wizards/wizard.js';
import EditComformation from '../wizards/assignments/edit_comfirmation_step.js';
import SelectActivities from '../wizards/assignments/edit_activities_type.js';

export default class AssignmentWizard extends React.Component {

    constructor(props) {
        let Steps = [EditComformation , SelectActivities];
        super(props);
        if (this.props.secondPhase== true) {
            Steps = [SelectActivities];
        }
        this.state = {steps:Steps, names:undefined}
    }

    onModify(steps, names){
        this.setState({steps:steps, names:names});
    }

    render() {
        return <div>
            <Wizard information={{homeworkID:this.props.homeworkID}} onModify={this.onModify.bind(this)} names={this.state.names}  stepsNavigation={true} steps={this.state.steps} />
        </div>;
    }

}


